import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { useRealAdminMetrics } from "@/hooks/useRealAdminMetrics";
import { PieChart as PieIcon } from "lucide-react";

const COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4", "#ec4899"];

const RealPlanDistribution = () => {
  const { planDistribution, loading } = useRealAdminMetrics();
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <PieIcon className="w-5 h-5 text-primary" />
          Distribuição de Planos (Real)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="h-72 animate-pulse bg-muted rounded" />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={planDistribution}
                dataKey="count"
                nameKey="plan"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={(e) => `${e.plan}: ${e.count}`}
              >
                {planDistribution.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default RealPlanDistribution;
